(function () {
  var LIMITS = window.cartQuantityLimits || {};
  var MSG = window.cartQuantityLimitMessages || {};
  if (!Object.keys(LIMITS).length) return;

  var origFetch = window.fetch.bind(window);
  var healing = false;

  function limitFor(productId) {
    return LIMITS[String(productId)] || null;
  }

  function toast(text) {
    if (!text) return;
    var el = document.getElementById('cql-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'cql-toast';
      el.className = 'cql-toast';
      el.setAttribute('role', 'alert');
      document.body.appendChild(el);
    }
    el.textContent = text;
    el.classList.add('cql-toast--visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('cql-toast--visible'); }, 5000);
  }

  try {
    var pending = sessionStorage.getItem('cqlToast');
    if (pending) { sessionStorage.removeItem('cqlToast'); setTimeout(function () { toast(pending); }, 400); }
  } catch (e) {}

  function getCart() {
    return origFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function applyInputLimits() {
    return getCart().then(function (cart) {
      var byIndex = {};
      cart.items.forEach(function (it, i) { byIndex[i + 1] = it; });

      document.querySelectorAll('input[data-index]').forEach(function (input) {
        var idx = parseInt(input.getAttribute('data-index'), 10);
        var item = byIndex[idx];
        if (!item) return;
        var lim = limitFor(item.product_id);
        if (!lim) return;
        if (lim.max != null) input.setAttribute('max', String(lim.max));
        if (lim.min != null) input.setAttribute('min', String(lim.min));
        if (input.dataset.cqlBound) return;
        input.dataset.cqlBound = '1';
        input.addEventListener('change', function () {
          var v = parseInt(input.value, 10);
          if (isNaN(v)) return;
          if (lim.max != null && v > lim.max) { input.value = String(lim.max); toast(MSG.max); }
          if (lim.min != null && v > 0 && v < lim.min) { input.value = String(lim.min); toast(MSG.min); }
        }, true);
      });
    }).catch(function () {});
  }

  function applyProductForm() {
    var pid = null;
    try { pid = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.id; } catch (e) {}
    if (!pid) return;
    var lim = limitFor(pid);
    if (!lim) return;
    document.querySelectorAll('input[name="quantity"], quantity-input input').forEach(function (qty) {
      if (qty.hasAttribute('data-index')) return;
      if (qty.closest('cart-drawer, #CartDrawer, cart-notification, #cart-notification, cart-items, #main-cart-items, .cart-item')) return;
      if (lim.max != null) qty.setAttribute('max', String(lim.max));
      if (lim.min != null) {
        qty.setAttribute('min', String(lim.min));
        if (parseInt(qty.value, 10) < lim.min) qty.value = String(lim.min);
      }
    });
  }

  function selfHeal() {
    if (healing) return Promise.resolve();
    return getCart().then(function (cart) {
      var fixes = [];
      var msg = '';
      cart.items.forEach(function (item) {
        var lim = limitFor(item.product_id);
        if (!lim) return;
        var target = item.quantity;
        if (lim.max != null && item.quantity > lim.max) { target = lim.max; msg = MSG.max; }
        if (lim.min != null && item.quantity > 0 && item.quantity < lim.min) { target = lim.min; msg = MSG.min; }
        if (target !== item.quantity) fixes.push({ key: item.key, quantity: target });
      });
      if (!fixes.length) return;
      healing = true;
      var chain = Promise.resolve();
      fixes.forEach(function (f) {
        chain = chain.then(function () {
          return origFetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: f.key, quantity: f.quantity })
          });
        });
      });
      return chain.then(function () {
        healing = false;
        try { if (msg) sessionStorage.setItem('cqlToast', msg); } catch (e) {}
        window.location.reload();
      });
    }).catch(function () { healing = false; });
  }

  window.fetch = function () {
    var args = arguments;
    var url = (args[0] && args[0].url) || args[0] || '';
    var p = origFetch.apply(this, args);
    if (typeof url === 'string' && /\/cart\/(add|change|update)(\.js)?/.test(url) && !healing) {
      p.then(function () { setTimeout(function () { applyInputLimits(); selfHeal(); }, 120); }).catch(function () {});
    }
    return p;
  };

  function run() { applyInputLimits(); applyProductForm(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  var target = document.querySelector('cart-drawer') || document.getElementById('main-cart-items') || document.body;
  if (target) {
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(applyInputLimits, 250); })
      .observe(target, { childList: true, subtree: true });
  }
})();
